<template>
    <div class="download page-container">
        <v-page-header
            :title="$t('下载中心')"
            :caption="$t('系统仅保留最近一年的导出下载记录')"
        />
        <div class="download-header">
            <span class="download-header-search">
                <v-input
                    v-model="searchValue"
                    @search="filterList"
                    @enter="filterList"
                    name="product"
                    kind="search"
                    :placeholder="$t('搜索')"
                    style="width:200px;"
                />
            </span>
            <span class="download-header-import">
                <span class="download-header-tip">{{ $t('导出模块') }}</span>
                <v-select
                    :options="importOptions"
                    v-model="selectModule"
                    @change="filterList"
                    max-height="unset"
                    :placeholder="$t('全部模块')"
                />
            </span>
            <span class="download-header-date">
                <span class="download-header-tip">{{ $t('时间范围') }}</span>
                <v-date-picker
                    v-model="selectDate"
                    :min-date="366"
                    :max-date="0"
                    @confirm="confirmDate"
                    @clear="clear"
                    enable-timer
                    clearable
                    clazz="downloadCenter-datePicker"
                />
            </span>
            <span class="download-header-status">
                <span class="download-header-tip">{{ $t('状态') }}</span>
                <v-select
                    :options="statusOptions"
                    v-model="selectStatus"
                    @change="filterList"
                    :placeholder="$t('全部')"
                />
            </span>
        </div>
        <v-table
            :data="options"
            :header-fix="true"
            @paginationChange="paginationChange"
            :loading="loading"
            fixed-row-height
            class="download-table"
        >
            <v-table-column
                v-for="column in columns"
                :key="column.label"
                :column-key="column.columnKey"
                :label="column.label"
                :align="column.align"
                :sortable="column.sortable"
                :sort-order="column.sortOrder"
                :formatter="column.formatter"
                :class="column.class"
                :width="column.width"
            />
            <v-table-column
                column-key="operator"
                :label="$t('操作人')"
                align="left"
                width="180"
            >
                <div
                    slot="cell"

                    slot-scope="props"
                    column="total"
                >
                    <span>
                        {{ $t('{kfext}({role})', { kfext: props.row.kfext, role: props.row.kfext === props.row.kfuin ? $t('管理员') : $t('员工工号') }) }}
                    </span>
                </div>
            </v-table-column>
            <v-table-column
                column-key="total"
                :label="$t('数据量')"
                align="right"
                width="160"
                sortable
            >
                <div
                    slot="cell"

                    slot-scope="props"
                    column="total"
                >
                    <span>
                        {{ toComma(props.row.total) }}
                    </span>
                </div>
            </v-table-column>
            <v-table-column
                key="status"
                column-key="status"
                :label="$t('状态')"
                width="160"
            >
                <div
                    slot="cell"

                    slot-scope="props"
                    column="status"
                >
                    <p v-if="props.row.status === 1">
                        <v-tag
                            type="status"
                            kind="success"
                            :status-text="$t('成功')"
                        />
                    </p>
                    <p v-else-if="props.row.status === 4">
                        <v-tag
                            type="status"
                            kind="warning"
                            :status-text="$t('任务终止')"
                        />
                    </p>
                    <p v-else-if="props.row.status === 2">
                        <v-tag
                            type="status"
                            kind="danger"
                            :status-text="$t('失败')"
                        />
                    </p>
                    <p v-else-if="props.row.status === 3 || props.row.status === 0">
                        <v-tag
                            type="status"
                            kind="info"
                            :status-text="$t('导出中')"
                        />
                    </p>
                </div>
            </v-table-column>
            <v-table-column
                column-key="type_name"
                :label="$t('模块')"
                width="200"
            >
                <div
                    slot="cell"

                    slot-scope="props"
                    column="type_name"
                >
                    <span>
                        {{ $t(props.row.type_name) }}
                    </span>
                </div>
            </v-table-column>
            <v-table-column
                column-key="operation"
            >
                <div
                    slot="cell"
                    slot-scope="props"
                >
                    <v-button-group>
                        <v-button
                            @click="readDetail(props.row.detail_url)"
                            type="link"
                            kind="primary"
                        >
                            {{ $t('查看数据') }}
                        </v-button>
                        <v-button
                            v-if="props.row.status === 1"
                            @click="downloadFile(props.row.task_id)"
                            type="link"
                            kind="primary"
                        >
                            {{ $t('下载文件') }}
                        </v-button>
                        <v-button
                            v-if="(props.row.status === 2 || props.row.status === 4) && props.row.download_type === 1"
                            @click="retryExport(props.row.task_id)"
                            type="link"
                            kind="primary"
                        >
                            {{ $t('再次导出') }}
                        </v-button>
                        <v-button
                            v-if="props.row.status === 3 && props.row.download_type === 1"
                            @click="cancelTask(props.row.task_id)"
                            type="link"
                            kind="primary"
                        >
                            {{ $t('终止任务') }}
                        </v-button>
                        <v-button
                            v-if="props.row.status === 2"
                            v-popconfirm="`errorRes-${props.row.task_id}`"
                            type="link"
                            kind="primary"
                        >
                            {{ $t('失败原因') }}
                        </v-button>
                        <v-popconfirm
                            :ref="`errorRes-${props.row.task_id}`"
                            :use-arrow="false"
                            :footerConfig="{
                                cancel: {
                                    text: $t('知道了'),
                                }
                            }"
                            placement="bottom-end"
                            :title="$t('失败原因')"
                        >
                            <div class="demo-popconfirm-first">
                                {{ props.row.detail }}
                            </div>
                        </v-popconfirm>
                    </v-button-group>
                </div>
            </v-table-column>
        </v-table>
        <v-pagination
            v-show="total"
            :total="total"
            :index="page"
            :count="pageSize"
            :count-options="pagination.countOptions"
            @change="paginationChange"
        />
    </div>
</template>

<script>
import { toTimeString } from 'src/utils/formatDate';
import { toComma } from 'src/utils/numberTool';
import moment from 'moment';
import { ensureTranDictReady } from 'src/utils/ajax';
export default {
    components: {
    },
    data() {
        return {
            toComma,
            toTimeString,
            selectStatus: -1,
            selectModule: 0,
            searchValue: '',
            options: [],
            loading: false,
            pagination: {
                showQuick: true,
                countOptions: [10, 15, 30, 50],
                defaultPageSize: 10,
            },
            importOptions: [],
            statusOptions: [
                {
                    value: -1,
                    text: this.$t('全部'),
                    disabled: '',
                },
                {
                    value: 1,
                    text: this.$t('成功'),
                    disabled: '',
                },
                {
                    value: 2,
                    text: this.$t('失败'),
                    disabled: '',
                },
                {
                    value: 3,
                    text: this.$t('导出中'),
                    disabled: '',
                },
                {
                    value: 4,
                    text: this.$t('任务终止'),
                    disabled: '',
                },
            ],
            selectDate: [],
            columns: [
                {
                    label: this.$t('任务名称'),
                    sortable: false,
                    align: 'left',
                    columnKey: 'name',
                    class: 'v-table-content',
                },
                {
                    label: this.$t('导出时间'),
                    sortable: true,
                    align: 'left',
                    columnKey: 'update_time',
                    sortOrder: '',
                    formatter(value) {
                        return toTimeString(value);
                    },
                    width: 180,
                },
            ],
            page: 1,
            pageSize: 10,
            total: 0,
            startTime: 0,
            endTime: 0,
        };
    },
    watch: {
    },
    created() {
        const searchName = (window.location.search).match(/name=([\s\S]*)/) || [];
        this.searchValue =  searchName.length ? decodeURIComponent(searchName[1]) : '';
        // 先确保后端翻译词典就绪，再拉取依赖词典翻译的模块列表（避免下拉选项的 text 在词典到达前被一次性求值为中文原文）
        ensureTranDictReady().then(() => {
            this.fetchModuleList();
        });
        this.fetchList();
    },
    mounted() {
    },
    methods: {
        filterList() {
            this.page = 1;
            this.fetchList();
        },
        fetchModuleList() {
            this.$ajax.gatewayPost('/v1/dl/task_type').then((res) => {
                if (res && res.code === 0) {
                    const moduleList = (res.data && res.data.records) || [];
                    this.importOptions.push({
                        value: 0,
                        text: this.$t('全部'),
                    });
                    moduleList && moduleList.forEach((item) => {
                        this.importOptions.push({
                            value: item.type_id,
                            text: this.$t(item.type_name),
                        });
                    });
                } else {
                    this.$message.error(res.msg || this.$t('拉取导出模块信息失败'));
                }
            });
        },
        fetchList() {
            this.loading = true;
            const params = {
                offset: this.page - 1,
                limit: this.pageSize,
                name: this.searchValue,
                type: this.selectModule,
                status: this.selectStatus,
                start_time: this.startTime / 1000,
                end_time: this.endTime / 1000,
            };
            this.$ajax.gatewayPost('/v1/dl/list', params).then((res) => {
                if (res && res.code === 0) {
                    this.total = parseInt(res.data && res.data.total) || 0;
                    this.loading = false;
                    this.options = (res.data && res.data.records) || [];
                } else {
                    this.$message.error(res.message || this.$t('获取列表失败'));
                }
            })
                .catch((err) => {
                    this.$message.error(err.message || this.$t('获取列表失败'));
                });
        },
        paginationChange(current, pageSize) {
            this.page = current;
            this.pageSize = pageSize;
            this.fetchList();
        },
        readDetail(url) {
            if (url.length) window.open(url);
        },
        confirmDate(val) {
            if (val.length) {
                this.startTime = moment(val[0]).valueOf();
                this.endTime =  moment(val[1]).valueOf();
            }
            this.filterList();
        },
        clear() {
            this.startTime = 0;
            this.endTime = 0;
            this.fetchList();
        },
        cancelTask(id) {
            this.$ajax.gatewayPost('/v1/dl/cancel', { task_id: id }).then((res) => {
                if (res && res.code === 0) {
                    this.$message.success(this.$t('终止任务成功'));
                    this.fetchList();
                } else {
                    this.$message.error(res.message || this.$t('终止任务失败'));
                }
            })
                .catch((err) => {
                    this.$message.error(err.message || this.$t('终止任务失败'));
                });
        },
        retryExport(id) {
            this.$ajax.gatewayPost('/v1/dl/retry', { task_id: id }).then((res) => {
                if (res && res.code === 0) {
                    this.$message.success(this.$t('再次导出成功'));
                    this.fetchList();
                } else {
                    this.$message.error(res.message || this.$t('无法再次导出'));
                }
            })
                .catch((err) => {
                    this.$message.error(err.message || this.$t('无法再次导出'));
                });
        },
        downloadFile(id) {
            this.$ajax.gatewayPost('/v1/dl/download', { task_id: id }).then((res) => {
                if (res && res.code === 0) {
                    window.open(res.data && res.data.url);
                } else {
                    this.$message.error(res.message || this.$t('无法下载文件'));
                }
            })
                .catch((err) => {
                    this.$message.error(err.message || this.$t('无法下载文件'));
                });
        },

    },
};
</script>
<style lang="less">
@import './style.less';
</style>
